<template lang="pug">
label.label(v-if="label" :for="name") {{label}}
FormField(v-slot="$field" :name="name")
  InputNumber(
    v-model="$field.value"
    :inputId="$attrs.id || name"
    :inputClass="$attrs.class"
    :prefix="$attrs.prefix"
    :minFractionDigits="$attrs.minFractionDigits"
    :maxFractionDigits="$attrs.maxFractionDigits"
    :useGrouping="$attrs.useGrouping"
    :fluid="$attrs.fluid==false ? false : true"
    :min="$attrs.min"
    :step="$attrs.step"
  )
  Message(v-if="$field?.invalid && ($field?.touched || formSubmitted)" severity="error" size="small" variant="simple") {{ $field.error?.message }}
</template>

<script setup>
import { inject, ref } from 'vue'
import InputNumber from "primevue/inputnumber"
import { FormField } from '@primevue/forms';
import Message from 'primevue/message';

const formSubmitted = inject('appFormSubmitted', ref(false))

const props = defineProps({
  name:   { type: String, required: true },
  label:  { type: String, required: false },
})

defineOptions({inheritAttrs: false})
</script>